import { instance } from "../components/AxiosClient";

const getGeoCompanyApi = async () => {
    try {
        const response = await instance.get(`/v5/resource/manager/company/${process.env.REACT_APP_COM_CODE}/web/companykey`);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export { getGeoCompanyApi };
